// extracted by mini-css-extract-plugin
export default {"customersDropdown":"CustomerDropdownList_customersDropdown__BO7MS"};